import type { Moment } from '@this/src/lib/moment';
import moment from '@this/src/lib/moment';
import { observable } from 'mobx';

export interface HotelOrderItemAgodaTotalResponseArgs {
  reservation_date: string;
  hotel_element_total: number;
  hotel_element_price_total: number;
  order_item_original_price_total: number;
  order_item_original_price_price_total: number;
  order_item_price_details_price_total: number;
  agoda_reservation_total: number;
  agoda_reservation_price_total: number;
  agoda_price_unconvertible: boolean;
  exact_match: boolean;
  approved_at: string;
  approved_by: number;
  supplied_item_id: number;
}

export interface HotelOrderItemAgodaTotalArgs {
  reservationDate: Moment;
  hotelElementTotal: number;
  hotelElementPriceTotal: number;
  orderItemOriginalPriceTotal: number;
  orderItemOriginalPricePriceTotal: number;
  orderItemPriceDetailsPriceTotal: number;
  agodaReservationTotal: number;
  agodaReservationPriceTotal: number;
  agodaPriceUnconvertible: boolean;
  exactMatch: boolean;
  approvedAt: Moment | null;
  approvedBy: number | null;
  suppliedItemId: number | null;
}

export const convertHotelOrderItemAgodaTotalResponseToArgs = (
  args: HotelOrderItemAgodaTotalResponseArgs
): HotelOrderItemAgodaTotalArgs => ({
  reservationDate: moment(args.reservation_date),
  hotelElementTotal: args.hotel_element_total,
  hotelElementPriceTotal: args.hotel_element_price_total,
  orderItemOriginalPriceTotal: args.order_item_original_price_total,
  orderItemOriginalPricePriceTotal: args.order_item_original_price_price_total,
  orderItemPriceDetailsPriceTotal: args.order_item_price_details_price_total,
  agodaReservationTotal: args.agoda_reservation_total,
  agodaReservationPriceTotal: args.agoda_reservation_price_total,
  agodaPriceUnconvertible: args.agoda_price_unconvertible,
  exactMatch: args.exact_match,
  approvedAt: args.approved_at ? moment(args.approved_at) : null,
  approvedBy: args.approved_by || null,
  suppliedItemId: args.supplied_item_id || null
});

export default class HotelOrderItemAgodaTotal {
  @observable readonly reservationDate: Moment;

  @observable readonly hotelElementTotal: number;

  @observable readonly hotelElementPriceTotal: number;

  @observable readonly orderItemOriginalPriceTotal: number;

  @observable readonly orderItemOriginalPricePriceTotal: number;

  @observable readonly orderItemPriceDetailsPriceTotal: number;

  @observable readonly agodaReservationTotal: number;

  @observable readonly agodaReservationPriceTotal: number;

  @observable readonly agodaPriceUnconvertible: boolean;

  @observable readonly exactMatch: boolean;

  @observable approvedAt: Moment | null;

  @observable approvedBy: number | null;

  @observable suppliedItemId: number | null;

  constructor(args: HotelOrderItemAgodaTotalArgs) {
    this.reservationDate = args.reservationDate;
    this.hotelElementTotal = args.hotelElementTotal;
    this.hotelElementPriceTotal = args.hotelElementPriceTotal;
    this.orderItemOriginalPriceTotal = args.orderItemOriginalPriceTotal;
    this.orderItemOriginalPricePriceTotal = args.orderItemOriginalPricePriceTotal;
    this.orderItemPriceDetailsPriceTotal = args.orderItemPriceDetailsPriceTotal;
    this.agodaReservationTotal = args.agodaReservationTotal;
    this.agodaReservationPriceTotal = args.agodaReservationPriceTotal;
    this.agodaPriceUnconvertible = args.agodaPriceUnconvertible;
    this.exactMatch = args.exactMatch;
    this.approvedAt = args.approvedAt;
    this.approvedBy = args.approvedBy;
    this.suppliedItemId = args.suppliedItemId;
  }

  setApprovedAt(approvedAt?: string) {
    this.approvedAt = approvedAt ? moment(approvedAt) : null;
  }

  setApprovedBy(approvedBy?: number) {
    this.approvedBy = approvedBy || null;
  }

  setSuppliedItemId(suppliedItemId?: number) {
    this.suppliedItemId = suppliedItemId || null;
  }
}
